export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 1.5;
export const KEY = '16ec5d15-3f29-4cb3-bf15-78290f380c5d';
